module.exports = __webpack_public_path__ + "static/media/intro.a3d4c2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/intro.png
// module id = 227
// module chunks = 0